<template>
  <div 
    id="verticalNav"
    class="slider fixed h-screen flex-col-nowrap justify-items-center left-0 max-w-full
    text-naranja p-3 pt-16 z-500 bg-amarillo w-full  overflow-y-auto 
      overflow-x-hidden"
  >
    <font-icon 
      icon="times" 
      class="closeIcon absolute right-2 top-2 w-10 cursor-pointer text-azul
      active:text-azul hover:text-white mr-4 mt-4 "
      @click="toggleMenu"
    />
    <div 
      class="menuVertical flex flex-col justify-center items-center" 
    >
      <base-menu 
        :links="links" 
        mode="movil-mode flex flex-col flex-nowrap items-center w-fit font-heading text-3xl"
        :class="color"
        :links-mode="linksMode"
        @closeMenu="toggleMenu"
      >
      </base-menu>   
    </div>
  </div>
</template>

<script>
import isPage from '@/mixins/isPageMixin.js';

export default {
  mixins: [isPage],
  data() {
    return {
    }
  },
  computed: {
    linksMode() {
      if (this.isEncuentro) {
        //console.log('Encuentro linksMode')
        return "hover:text-white text-azul flex-row flex justify-start uppercase  py-8";
      } else {
        return "hover:text-white flex justify-start uppercase py-8";
      }
    }, 
    links() {
      if (this.isEncuentro2022) {
        //console.log('encuentro')
        return this.$store.getters.getLinks('encuentro2022');
      } else if (this.isEncuentro2024) {
        //console.log('encuentro')
        return this.$store.getters.getLinks('encuentro2024');
      } else if (this.isEncuentro2026) {
        //console.log('encuentro')
        return this.$store.getters.getLinks('encuentro2026');
      } else if (this.isProyecto || this.isArticulo || this.isNovedad || this.isRecreacion) {
        //console.log('proyectos')
        return this.$store.getters.getLinks('proyecto');  
      } else {
        //console.log('Home')
        //console.log(this.$store.getters.getLinks('home'))
        return this.$store.getters.getLinks('home');
      }
    },    
    isMovil() {
      return this.$store.getters.getMovilView;
    },
    color() {
      if (this.isEncuentro ) {
        return "text-amarillo active:text-amarillo";
      } else {
        return "text-naranja active:text-naranja ";
      }      
    }
  },
  created() {

  },
  methods: {
    toggleMenu() {
      //console.log('close menu')
      //Se debe cerrar el menu
      this.$store.dispatch('changeMenu')
    },
  },
}
</script>

<style >

  body.modal-open {
    overflow: hidden;
  }

  .modal-open .nav-item.resaltado {
    color: var(--color)
  }
  .modal-open :hover.nav-item.resaltado {
    color: var(--color-hover)    
  }
  .modal-open .nav-item svg {
    fill: var(--color)
  }
  .modal-open :hover.nav-item svg {
    fill: var(--color-hover)    
  }
  .modal-open .icon svg {
    width: 7rem;
  }

  .modal-open .nav-item{
    font-size: 1.5rem;
    line-height: 2rem;
    padding: 2rem 0vw !important;
  }

  .modal-open .nav-sub-item {
    font-size: 1rem !important;    
    line-height: 1.5rem;
  }

  .modal-open .submenu {
    padding: 0.8rem 0vw 0vw !important;
  }

  .modal-open.icon svg {
      width: 8rem;
  }

  .modal-open .br-span {
    display: block;
  }

  @media screen and (max-width: 240px) {
  .modal-open .menuVertical {
    margin-top: 2rem;
  }
  .modal-open .nav-item{
    font-size: 5vw;
    line-height: 6vw;
    padding: 5vw 0vw !important;
  }

  .modal-open .nav-sub-item {
    font-size: 4vw !important;    
    line-height: 5vw;
  }

  .modal-open .submenu {
    padding: 2vw 0vw 0vw !important;
  }

  .modal-open .icon svg {
      width: 35vw;
  }
}

  @media screen and (min-width: 350px) {
  .modal-open .nav-item{
    font-size: 2.3rem;
    line-height: 2.5rem;
    padding: 2rem 0vw !important;
  }

  .modal-open .nav-sub-item {
    font-size: 1.5rem !important;    
    line-height: 3rem;
  }

  .modal-open .submenu {
    padding: 0.8rem 0vw 0vw !important;
  }

  .modal-open .icon svg {
      width: 10rem;
  }
}

</style>